/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsThreadColor,
    SharedserviceMelcoModelsThreadColorFromJSON,
    SharedserviceMelcoModelsThreadColorFromJSONTyped,
    SharedserviceMelcoModelsThreadColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsColorListItem
 */
export interface SharedserviceMelcoModelsColorListItem {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    code?: string | null;
    /**
     * 
     * @type {SharedserviceMelcoModelsThreadColor}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    color?: SharedserviceMelcoModelsThreadColor;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    type?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    weight_list?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsColorListItem
     */
    product_name?: string | null;
}

export function SharedserviceMelcoModelsColorListItemFromJSON(json: any): SharedserviceMelcoModelsColorListItem {
    return SharedserviceMelcoModelsColorListItemFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : SharedserviceMelcoModelsThreadColorFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight_list': !exists(json, 'weight_list') ? undefined : json['weight_list'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function SharedserviceMelcoModelsColorListItemToJSON(value?: SharedserviceMelcoModelsColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'color': SharedserviceMelcoModelsThreadColorToJSON(value.color),
        'type': value.type,
        'weight_list': value.weight_list,
        'supplier_name': value.supplier_name,
        'product_name': value.product_name,
    };
}


